export default __webpack_public_path__ + "static/media/online-meeting.06246363.svg";